import axios from 'axios';
import { apiHelper } from '@/helpers/index';

/**
 * Function connecting to an API and extracting the string data
 * @returns a string containing the CSS style taken from the API
 */
const searchCssService = async function() {
  //expositionPath needs to be obtained from the store later on
  const expositionPath = apiHelper.getURI();
  const resp = await axios.get(`${expositionPath}/publicSettings`, {});
  return resp.data && resp.data.customCSS && resp.data.customCSS.annuaireAssos;
};

export { searchCssService };
